export default {
  housing_interests:
    'El valor de intereses en préstamos para adquisición de vivienda (o el costo financiero en un contrato de leasing) que el empleado pagó en el año anterior y dividido por meses.',
  prepaid_medicine:
    'El valor de los pagos a medicina prepagada del trabajador, el cónyuge, y sus hijos y dependientes que el empleado pagó durante el año anterior y dividido por meses.',
  dependents_deduction:
    'Selecciona "Sí" solo si el empleado declaró que tiene personas a cargo.',
}
